import { IconProps } from "../../../types/style";

const UnauthorizedSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M5.37494 1.22491C5.72494 0.929912 6.28994 0.929912 6.62994 1.22491L7.41994 1.89991C7.56994 2.02491 7.85494 2.12991 8.05494 2.12991H8.90494C9.43494 2.12991 9.86994 2.56491 9.86994 3.09491V3.94491C9.86994 4.14491 9.97494 4.42491 10.0999 4.57491L10.7749 5.36491C11.0699 5.71491 11.0699 6.27991 10.7749 6.61991L10.0999 7.40991C9.97494 7.55991 9.86994 7.83991 9.86994 8.03991V8.88991C9.86994 9.41991 9.43494 9.85491 8.90494 9.85491H8.05494C7.85494 9.85491 7.57494 9.95991 7.42494 10.0849L6.63494 10.7599C6.28494 11.0549 5.71994 11.0549 5.37994 10.7599L4.58994 10.0849C4.43994 9.95991 4.15494 9.85491 3.95994 9.85491H3.08494C2.55494 9.85491 2.11994 9.41991 2.11994 8.88991V8.03491C2.11994 7.83991 2.01994 7.55491 1.89494 7.40991L1.21994 6.61491C0.929941 6.26991 0.929941 5.70991 1.21994 5.36491L1.89494 4.56991C2.01994 4.41991 2.11994 4.13991 2.11994 3.94491V3.09991C2.11994 2.56991 2.55494 2.13491 3.08494 2.13491H3.94994C4.14994 2.13491 4.42994 2.02991 4.57994 1.90491L5.37494 1.22491Z"
          fill="#D99036"
        />
        <path
          d="M6 8.43457C5.725 8.43457 5.5 8.20957 5.5 7.93457C5.5 7.65957 5.72 7.43457 6 7.43457C6.275 7.43457 6.5 7.65957 6.5 7.93457C6.5 8.20957 6.28 8.43457 6 8.43457Z"
          fill="#D99036"
        />
        <path
          d="M6 6.86043C5.795 6.86043 5.625 6.69043 5.625 6.48543V4.06543C5.625 3.86043 5.795 3.69043 6 3.69043C6.205 3.69043 6.375 3.86043 6.375 4.06543V6.48043C6.375 6.69043 6.21 6.86043 6 6.86043Z"
          fill="#D99036"
        />
      </svg>
    </div>
  );
};

export default UnauthorizedSVG;
